import moment from 'moment';
import utils from '../../utils';
import { conditions, machiningFields, textFields } from './machiningFields';

export function exportMasterData(kind, assets, categories, companyName) {
    const definition = machiningFields[kind];
    const categoryNames = new Map(
        categories.map((category) => [String(category.category), category.description])
    );
    const fields = [
        ['id', 'ID'],
        [definition.number, definition.numberLabel],
        ...textFields.map(([field, label]) => [field, label]),
        ['category', 'Category No.'],
        ['categoryName', 'Category'],
        ['assetCondition', 'Condition'],
        ['manufactureYear', 'Manufacture year'],
        ['commissionedOn', 'Commissioned on'],
        ['warrantyExpiresOn', 'Warranty expires on'],
        ['maintenanceRequirement', 'Maintenance required'],
        ['remarks', 'Remarks'],
        ['active', 'Active'],
        ['company', 'Company ID'],
        ['companyName', 'Company'],
        ['technicalSpecifications', 'Technical specifications'],
        ['createdAt', 'Created at'],
        ['createdBy', 'Created by'],
        ['updatedAt', 'Updated at'],
        ['updatedBy', 'Updated by'],
    ];

    if (kind === 'machines') {
        fields.push(['description', 'Legacy description']);
    }

    const table = document.createElement('table');
    const header = table.createTHead().insertRow();

    fields.forEach(([, label]) => {
        const cell = document.createElement('th');
        cell.textContent = label;
        header.appendChild(cell);
    });

    const body = table.createTBody();

    assets.forEach((asset) => {
        const values = {
            ...asset,
            categoryName: categoryNames.get(String(asset.category)) || '',
            companyName: companyName || '',
            assetCondition: asset.assetCondition == null ? '' : conditions[asset.assetCondition],
            technicalSpecifications: (asset.technicalSpecifications || [])
                .map((document) => document.originalName)
                .join('; '),
        };
        const row = body.insertRow();

        fields.forEach(([field]) => {
            const value = values[field];
            const cell = row.insertCell();

            // Keep identifiers and leading zeros intact when Excel opens the HTML workbook.
            cell.setAttribute('style', 'mso-number-format:"\\@";');
            cell.textContent =
                typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value ?? '');
        });
    });

    utils.tableToExcel(table, kind, `${kind}_Master_Data_${moment().format('YYYYMMDD')}.xls`);
}
